import { Rule } from "antd/lib/form";

export const generalValidationRules: Rule[] = [
  { required: true, message: "Field is required!" },
];

/*export const textInputValidationRules: Rule[] = [
  ...generalValidationRules,
  { whitespace: true },
];*/

export const textInputValidationRules: Rule[] = [
  {
    whitespace: true,
    message: 'Input cannot be empty',
  },
  {
    validator: (_, value) => {
      if (!value || /^[a-zA-Z\s]*$/.test(value)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Input can only contain alphabet characters'));
    },
  },
];

export const textnameInputValidationRules = (role: string, is_corporate: boolean): Rule[] => [
  {
    whitespace: true,
    message: "Full Name cannot be empty",
  },
  {
    validator: (_, value) => {
      if (!value) {
        return Promise.reject(new Error("Full Name cannot be empty"));
      }


      if (role === "talent") {
        const words = value.trim().split(/\s+/);
        if (words.length >= 2 && /^[a-zA-Z\s-]*$/.test(value)) {
          return Promise.resolve();
        } else {
          return Promise.reject(
            new Error("Please enter your full name (e.g., Firstname Surname)")
          );
        }
      }


      if (role === "recruiter" || is_corporate) {
        if (/^[a-zA-Z-]+(?: [a-zA-Z-]+)*$/.test(value)) {
          return Promise.resolve();
        } else {
          return Promise.reject(
            new Error("Name can only contain letters, hyphens")
          );
        }
      }


      return Promise.resolve();
    },
  },
];

export const nameInputValidationRules: Rule[] = [
  {
    whitespace: true,
    message: 'Full Name cannot be empty',
    required: true,
  },
  {
    validator: (_, value) => {

      if (!value || /^[a-zA-Z\s-]*$/.test(value)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('Input can only contain alphabet characters, spaces, and hyphens'));
    },
  },
];

export const textInputValidationRulesOpt: Rule[] = [
  { whitespace: true },
  { required: false },
];

export const rcNumberValidationRule = {
  pattern: /^(RC)?\d{6,7}$/,
  message: "Company RC Number should be a 6-7 digit number, optionally prefixed with 'RC'."
};

export const companySizeValidationRule = {
  pattern: /^[0-9]+$/,
  message: "Company size should be a numeric value."
};


export const validateURL = (rule: any, value: string) => {
  if (!value) return Promise.resolve();
  const generalURLRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ;,./?%&=]*)?$/;

  const linkedinRegex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
  const behanceRegex = /^https:\/\/(www\.)?behance\.net\/[a-zA-Z0-9_-]+\/?$/;
  const githubRegex = /^https:\/\/(www\.)?github\.com\/[a-zA-Z0-9_-]+\/?$/;
  const facebookRegex = /^https:\/\/(www\.)?facebook\.com\/[a-zA-Z0-9.-]+\/?$/;
  const instagramRegex = /^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_-]+\/?$/;
  const twitterRegex = /^https:\/\/(www\.)?twitter\.com\/[a-zA-Z0-9_-]+\/?$/;

  if (generalURLRegex.test(value)) {
    return Promise.resolve();  // Valid general URL.
  }

  if (
    linkedinRegex.test(value) ||
    behanceRegex.test(value) ||
    githubRegex.test(value) ||
    facebookRegex.test(value) ||
    instagramRegex.test(value) ||
    twitterRegex.test(value)
  ) {
    return Promise.resolve();
  } else {
    return Promise.reject("Please enter a valid URL for the respective platform.");
  }
};


export const aboutCompanyValidationRule = {
  pattern: /^[a-zA-Z\s,.'-]+$/,
  message: "About Company should only contain letters, spaces, and symbols (no numbers)."
};


export const emailValidationRules: Rule[] = [
  {
    required: true,
    message: "Field is required",
  },
  {
    type: "email",
    message: "Invalid Email Address",
  },
];


export const signupemailValidationRules = (is_corporate: boolean): Rule[] => [
  {
    required: true,
    message: "Field is required",
  },
  {
    type: "email",
    message: "Invalid Email Address",
  },
  ...(is_corporate
    ? [
      {
        validator(_: any, value: string) {
          const corporateEmailRegex = /^[a-zA-Z0-9._%+-]+@(?!gmail\.com|yahoo\.com|outlook\.com)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!value || corporateEmailRegex.test(value)) {
            return Promise.resolve();
          }
          return Promise.reject("Please use a corporate email address.");
        },
      },
    ]
    : []),
];

export const passwordValidationRules: Rule[] = [
  {
    required: true,
  },
  { message: "Field is required" },

  {
    validator: async (rule, value) => {
      let paswd =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,}$/;

      if (!paswd.test(value))
        throw new Error(
          "Password should contain at least one digit and special character and a letter in uppercase, and least 8 characters"
        );
      // if (false) throw new Error("Something wrong!");
      return true;
    },
  },
];


export const phoneNumberValidationRule: Rule[] = [
  { required: false, message: "Please enter phone number" },
  {
    validator: (_: any, value: string, callback: (error?: string) => void) => {
      const phoneRegex = /^[+]?\d*$/;

      if (value && !phoneRegex.test(value)) {
        callback("Please enter only digits and an optional '+' sign");
      } else {
        callback();
      }
    },
  },
];

export const integerValidationRules: Rule[] = [
  { required: true, message: "Please enter number" },
  {
    validator: (_: any, value: number, callback: (error?: string) => void) => {
      if (isNaN(value)) {
        callback("Please enter only digits");
      } else {
        callback();
      }
    },
  },
];
